// extracted by mini-css-extract-plugin
export default {"btn":"ButtonWithBubbles_btn__GGy3g","btn_text":"ButtonWithBubbles_btn_text__zBS0X","border":"ButtonWithBubbles_border__mMbwv","btn_bg":"ButtonWithBubbles_btn_bg__bWHwj"};